import { useCallback, useEffect, useRef, useState } from "react";

export const useMicRecorder = () => {
  const [recording, setRecording] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [level, setLevel] = useState(0);
  const [error, setError] = useState("");
  const chunksRef = useRef([]);
  const ctxRef = useRef(null);
  const streamRef = useRef(null);
  const timerRef = useRef(null);

  const cleanup = useCallback(() => {
    clearInterval(timerRef.current);
    ctxRef.current?.close().catch(() => {});
    streamRef.current?.getTracks().forEach((t) => t.stop());
    ctxRef.current = null;
    streamRef.current = null;
  }, []);

  const start = useCallback(async () => {
    setError("");
    chunksRef.current = [];
    setSeconds(0);
    let stream;
    try {
      stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true } });
    } catch (e) {
      setError("Microfono non consentito: abilita il permesso nel browser.");
      return false;
    }
    streamRef.current = stream;
    const ctx = new AudioContext();
    ctxRef.current = ctx;
    await ctx.audioWorklet.addModule("/pcm-worklet.js");
    const node = new AudioWorkletNode(ctx, "pcm16-worklet");
    let frames = 0;
    node.port.onmessage = (e) => {
      chunksRef.current.push(new Uint8Array(e.data.buffer));
      if (++frames % 5 === 0) setLevel(e.data.level);
    };
    ctx.createMediaStreamSource(stream).connect(node);
    const t0 = Date.now();
    timerRef.current = setInterval(() => setSeconds(Math.floor((Date.now() - t0) / 1000)), 250);
    setRecording(true);
    return true;
  }, []);

  const stop = useCallback(() => {
    cleanup();
    setRecording(false);
    setLevel(0);
    const total = chunksRef.current.reduce((n, c) => n + c.length, 0);
    const out = new Uint8Array(total);
    let off = 0;
    for (const c of chunksRef.current) {
      out.set(c, off);
      off += c.length;
    }
    return out;
  }, [cleanup]);

  useEffect(() => cleanup, [cleanup]);

  return { recording, seconds, level, error, start, stop };
};
